import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {telHref} from "@/shared/lib";
import {type ResponsiveSize, Typography} from "@/shared/ui/data-display/typography/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/phone-number.scss";

export type {ResponsiveSize};

/** Parsed contact phone line: label (e.g. "Mexico", "Toll-Free Number") and number */
export interface ContactPhoneItem {
    label: string;
    number: string;
}

export interface PhoneNumberProps extends Omit<ContactPhoneItem, "label"> {
    /** Optional label (e.g. "Mexico", "International") */
    label?: string;
    /** Show label when provided; default true. Set false to hide label. */
    showLabel?: boolean;
    /** Icon size in px; default 24. Use to match display size for crisp rendering. */
    iconSize?: number;
    /** Font size for label and number: number (e.g. 14) or { desktop: 14, mobile: 12 }. */
    size?: ResponsiveSize;
    className?: string;
}

export function PhoneNumber({number, label, showLabel = true, iconSize = 24, size, className = ""}: PhoneNumberProps): JSX.Element {
    const showLabelContent = showLabel && label;
    return (
        <a href={telHref(number)} className={`phone-number ${className}`.trim()}>
            <span className="phone-number__icon" aria-hidden>
                <SmartImage src={assetPath("/images/icons/phone.svg")} alt="" width={iconSize} height={iconSize} />
            </span>
            <span className="phone-number__text">
                {showLabelContent ? (
                    <Typography as="span" className="phone-number__label" size={size} color="paragraph2">
                        {label}:{" "}
                    </Typography>
                ) : null}
                <Typography as="span" className="phone-number__number" size={size} color="primary" weight={600}>
                    {number}
                </Typography>
            </span>
        </a>
    );
}
